import {VersionVariants} from '@jobseeker/lotus/enums';
import {
  Tooltip as MuiTooltip,
  styled,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';

const TooltipV1 = styled(({className, ...props}: TooltipProps) => (
  <MuiTooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  ul: {
    margin: 0,
    paddingLeft: 10,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#EEF2F6',
    color: theme.palette.secondary.light,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
  },
  '.MuiTooltip-arrow:before': {
    backgroundColor: '#EEF2F6',
  },
}));

const TooltipHirist = styled(({className, ...props}: TooltipProps) => (
  <MuiTooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  ul: {
    margin: 0,
    padding: '14px 15px',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#1c2d41',
    color: '#fff',
    fontSize: 16,
    // border: '1px solid #dadde9',
  },
  '.MuiTooltip-arrow:before': {
    backgroundColor: '#1c2d41',
  },
}));

const Tooltip = (props: TooltipProps & {variant?: VersionVariants}) => {
  if (props?.variant === VersionVariants.VERSION_HIRIST) {
    return <TooltipHirist {...props} />;
  }

  return <TooltipV1 {...props} />;
};

export const TooltipStyled = styled(
  ({className, isGrey, ...props}: TooltipProps & {isGrey?: boolean}) => (
    <MuiTooltip {...props} classes={{popper: className}} />
  )
)(({theme, isGrey}) => ({
  zIndex: 10,
  [`& .${tooltipClasses.arrow}::before`]: {
    background: isGrey
      ? '#6E6E6E'
      : 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: isGrey
      ? '#6E6E6E'
      : 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
    padding: theme.spacing(isGrey ? 1 : 1.5, 1.25),
    borderRadius: '10px',
    color: '#fff',
    fontSize: 11,
    maxWidth: 380,
    marginTop: isGrey ? '18px !important' : '14px',
  },
}));

export default Tooltip;
